import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/nebulosas")({
  head: () => labHead(
    "/lab/nebulosas",
    "Nebulosas",
    "Gerador do Atlas das nebulosas: cada nebulosa é um lugar numa data, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: NebulaeLab,
});

function NebulaeLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/?obra=nebulosa" title={{ pt: "Nebulosas", en: "Nebulae", es: "Nebulosas" }} />;
}
